import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getPostById } from "../services/postService";
import { useAppContext } from "../context/AppContext";
import { Helmet } from "react-helmet";
import { BlogTrans } from "../utils/translations";

const BlogPostPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language } = useAppContext();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const data = await getPostById(id);
        setPost(data);
      } catch (error) {
        console.error("Error fetching post:", error);
      }
    };
    fetchPost();
  }, [id]);

  if (!post) {
    return <div className="text-center py-20 text-xl">Loading...</div>;
  }

  // Strip HTML and truncate to 160 characters for meta description
  const plainText = post.content.replace(/(<([^>]+)>)/gi, "");
  const description = plainText.slice(0, 160) + (plainText.length > 160 ? "..." : "");

  return (
    <>
      <Helmet>
        <title>{post.title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content="yoga, wellness, blog, once upon a mat" />

        {/* Open Graph (Facebook, LinkedIn) */}
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={post.image} />
        <meta property="og:type" content="article" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={post.title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={post.image} />
      </Helmet>

      <main className="min-h-screen px-4 md:px-20 py-10 max-w-4xl mx-auto">
        <button
          className="text-[#D27B5E] hover:underline text-sm mt-4"
          onClick={() => navigate(-1)}
        >
          {BlogTrans[language].return}
        </button>
        <h1 className="text-3xl md:text-4xl font-bold mb-4">{post.title}</h1>
        <div className="text-sm text-gray-500 mb-6">
          <span>
            {new Intl.DateTimeFormat('en-GB', {
              day: 'numeric',
              month: 'numeric',
              year: 'numeric',
            }).format(new Date(post.date))}
          </span>
        </div>
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-64 object-cover rounded-xl mb-8"
        />
        <article
          className="prose prose-lg max-w-none text-left space-y-4"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      </main>
    </>
  );
};

export default BlogPostPage;
